"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Pagination.scss");
var _NonTimeBasedListEntriesMethods = require("../NonTimeBasedListEntries/NonTimeBasedListEntriesMethods");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Pagination = _ref => {
  let {
    data,
    RenderComponent,
    pageLimit,
    dataLimit = 20
  } = _ref;
  const [pages] = (0, _react.useState)(pageLimit);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [nextDisabled, setNextDisabled] = (0, _react.useState)(false);
  const [prevDisabled, setPrevDisabled] = (0, _react.useState)(false);
  const paginationContainer = (0, _react.useRef)(null);
  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
    const group = new Array(pageLimit).fill().map((_, idx) => start + idx + 1);
    return group;
  };
  function goToPreviousPage() {
    setCurrentPage(page => page - 1);
  }
  function goToNextPage() {
    setCurrentPage(page => page + 1);
  }
  function changePage(event) {
    const pageNumber = Number(event.target.textContent);
    setCurrentPage(pageNumber);
  }
  (0, _react.useEffect)(() => {
    currentPage === 1 ? setPrevDisabled(true) : setPrevDisabled(false);
    currentPage === pages ? setNextDisabled(true) : setNextDisabled(false);
    window.scroll({
      top: paginationContainer.current.offsetTop > 150 ? paginationContainer.current.offsetTop - 150 : paginationContainer.current.offsetTop,
      // 150px accounts for open nav height
      left: 0,
      behavior: "smooth"
    });
  }, [currentPage, pages]);
  const returnPaginationPages = () => {
    return getPaginationGroup().map((item, index) => /*#__PURE__*/_react.default.createElement("button", {
      key: index,
      onClick: changePage,
      className: `ter-pagination__item ${currentPage === item ? "ter-pagination__item--active" : null}`
    }, /*#__PURE__*/_react.default.createElement("span", null, item)));
  };
  const displayPagination = () => {
    if (getPaginationGroup().length > 1) {
      return true;
    }
    return false;
  };
  const returnRenderComponent = (data, RenderComponent) => {
    const startIndex = currentPage * dataLimit - dataLimit;
    const endIndex = startIndex + dataLimit;
    const slicedData = data?.slice(startIndex, endIndex);
    if (RenderComponent === "LongDescriptionCard") {
      return slicedData?.map((item, i) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: `${item}-${i}`
      }, /*#__PURE__*/_react.default.createElement(_NonTimeBasedListEntriesMethods.LongDescriptionCard, {
        key: i,
        eyebrow: item?.eyebrow,
        header: item?.header,
        subhead: item?.subhead,
        link: item?.link,
        ariaLabel: item?.customAriaLabel,
        image: item?.image,
        summary: item?.summary,
        contentfulId: item?.contentfulId
      })));
    } else if (RenderComponent === "ShortDescriptionCard") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "cards-group"
      }, slicedData?.length > 1 ? slicedData.map((entry, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: `${entry}-${index}`
      }, /*#__PURE__*/_react.default.createElement(_NonTimeBasedListEntriesMethods.ShortDescriptionCard, {
        header: entry?.header,
        link: entry?.link,
        category: entry?.industryCategory,
        role: entry?.role,
        ariaLabel: entry?.customAriaLabel,
        contentfulId: entry?.contentfulId
      }))) : /*#__PURE__*/_react.default.createElement(_NonTimeBasedListEntriesMethods.ShortDescriptionCard, {
        header: slicedData[0]?.header,
        link: slicedData[0]?.link,
        category: slicedData[0]?.industryCategory,
        role: slicedData[0]?.role,
        ariaLabel: slicedData[0]?.customAriaLabel,
        contentfulId: islicedData[0]?.contentfulId
      }));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: paginationContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-paginated-data"
  }, returnRenderComponent(data, RenderComponent)), displayPagination() && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pagination"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: goToPreviousPage,
    className: `ter-pagination__button ter-pagination__button--prev ${prevDisabled ? "ter-pagination__disabled" : ""}`
  }, "Prev"), returnPaginationPages(), /*#__PURE__*/_react.default.createElement("button", {
    onClick: goToNextPage,
    className: `ter-pagination__button ter-pagination__button--next ${nextDisabled ? "ter-pagination__disabled" : ""}`
  }, "Next")));
};
var _default = Pagination;
exports.default = _default;